import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Card, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FaStar } from "react-icons/fa";
import "./ShopByCategory.css";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get("https://madhusewingmachines.com/api/reviews"); // Update with your API URL
        setTestimonials(response.data);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <Container fluid className="py-5" style={{ backgroundColor: "#EFFBFF" }}>
      <h2 className="category-heading">⭐ Our Happy Customers ⭐</h2>

      <Swiper
        slidesPerView={1}
        spaceBetween={20}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className="mySwiper"
      >
        {testimonials.length > 0 ? (
          testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial._id}>
              <Card className="shadow-sm mx-auto p-4" style={{ maxWidth: "800px", borderRadius: "12px" }}>
                <Row className="align-items-center">
                  <Col xs={3} className="text-center">
                    <img
                      src={`https://madhusewingmachines.com/uploads/${testimonial.image}`} // Ensure correct path
                      alt={testimonial.name}
                      className="rounded-circle"
                      style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    />

                  </Col>
                  <Col xs={9}>
                    <h5 className="fw-bold mb-1">{testimonial.name}</h5>
                    <p className="text-muted mb-2">{testimonial.location}</p>
                  </Col>
                </Row>
                <div className="mt-2">
                  {/* Star Ratings */}
                  <div>
                    {[...Array(testimonial.rating)].map((_, index) => (
                      <FaStar key={index} size={18} color="gold" />
                    ))}
                  </div>
                  {/* Review Text */}
                  <p className="mt-2 fst-italic text-muted">{testimonial.review}</p>
                </div>
              </Card>
            </SwiperSlide>
          ))
        ) : (
          <p className="text-center text-muted">No reviews available</p>
        )}
      </Swiper>
    </Container>
  );
};

export default Testimonials;
